import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { get, capitalize, trim, isEmpty } from 'lodash';
import { Button } from 'semantic-ui-react';
import ErrorMessage from '../ErrorMessage';
import ProdigyInput from '../Inputs/ProdigyInput';
import './AppConfigurations.scss';

const compareVersion = ({ currentVersion, existingVersion = '0.0' }) => {
  // check if current verion is lower than existing version
  const currentVersionArr = currentVersion.split('.').map(i => parseInt(i, 10));
  const existingVersionArr = existingVersion
    .split('.')
    .map(i => parseInt(i, 10));

  if (currentVersionArr[0] > existingVersionArr[0]) {
    return false;
  }
  if (currentVersionArr[0] < existingVersionArr[0]) {
    return true;
  }

  if (currentVersionArr[1] > existingVersionArr[1]) {
    return false;
  }
  if (currentVersionArr[1] < existingVersionArr[1]) {
    return true;
  }

  return currentVersionArr[2] < existingVersionArr[2];
};

function AppConfiguration({ actions, appConfigurations, appName }) {
  const appConfiguration = get(
    appConfigurations,
    `appConfigurations.${appName}`,
    {},
  );
  const appConfigurationVersionNumber = get(
    appConfiguration,
    'min_version',
    '0.0',
  );
  const [version, setVersion] = useState(appConfigurationVersionNumber);
  const [valid, setValid] = useState(true);

  const validateVersion = newVersion => {
    const versionArr = newVersion.split('.');
    const isValid =
      versionArr.length === 2 &&
      newVersion === versionArr.map(v => parseInt(v, 10)).join('.');
    setValid(isValid);
  };

  useEffect(() => {
    if (isEmpty(appConfiguration)) {
      actions.appConfigurationRequest(appName);
    }
  }, [appConfiguration, actions, appName]);

  useEffect(() => {
    setVersion(appConfigurationVersionNumber);
    validateVersion(appConfigurationVersionNumber);
  }, [appConfigurationVersionNumber]);

  const onVersionChange = value => {
    const formattedValue = trim(value);
    setVersion(formattedValue);
    validateVersion(formattedValue);
  };

  const onSave = () => {
    const configurationPayload = {
      id: appName,
      name: appName,
      min_version: version,
    };
    const saveAction = isEmpty(appConfiguration)
      ? actions.createAppConfigurationRequest
      : actions.updateAppConfigurationRequest;
    saveAction(configurationPayload);
  };

  return (
    <div className="app-configuration">
      <div className="app-name">{capitalize(appName)}</div>
      <ProdigyInput
        value={version}
        label="Min Version"
        onChangeHandler={onVersionChange}
        required
      />
      {!valid && <ErrorMessage error="Please enter a valid version" />}
      <Button
        color="blue"
        type="button"
        onClick={onSave}
        disabled={!valid || version === appConfigurationVersionNumber}
      >
        Save
      </Button>
      {valid &&
        compareVersion({
          currentVersion: version,
          existingVersion: appConfigurationVersionNumber,
        }) && (
          <span className="app-version-notice">{`Note: new version is lower than the current value (${appConfigurationVersionNumber}), please verify before save`}</span>
        )}
    </div>
  );
}

AppConfiguration.propTypes = {
  actions: PropTypes.object,
  appConfigurations: PropTypes.object,
  appName: PropTypes.string,
};

export default AppConfiguration;
